var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"coords":_vm.coords,"zoom":18}},[_c('ymap-marker',{attrs:{"coords":_vm.coords,"marker-id":"123","hint-content":"ОГБПОУ Северский промышленный колледж"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }